import { Column } from "react-table";
import { FormattedMessage, IntlShape } from "react-intl";

import { ReactComponent as CheckIcon } from "assets/images/icons/Check.svg";
import { getLabelWithTranslationFallback } from "helpers/getLabel";

const getPrefillsColumns = (intl: IntlShape) => {
  const columns: Column[] = [
    {
      id: "location",
      Header: getLabelWithTranslationFallback("Payment location", {
        style: "capitalize",
        translation: <FormattedMessage id="general.paymentLocations" defaultMessage="Payment locations" />,
      }),
      accessor: "location",
      sortable: false,
      Cell: ({ value }: any) => <div>{value.label}</div>,
    },
    {
      id: "input_field",
      Header: intl.formatMessage({
        id: "settings.prefills.inputField",
        defaultMessage: "Input Field",
      }),
      accessor: "input_field_label",
      sortable: false,
      Cell: ({ value }: { value: string }) => <div className="font-weight-bold">{value}</div>,
    },
    {
      id: "input_value",
      Header: intl.formatMessage({
        id: "settings.prefills.inputValue",
        defaultMessage: "Input Value",
      }),
      accessor: (row: any) => row.input_value_label || row.input_value,
      sortable: false,
      Cell: ({ value }: any) => <div>{value}</div>,
    },
    {
      id: "output_field",
      Header: intl.formatMessage({
        id: "settings.prefills.outputField",
        defaultMessage: "Output field",
      }),
      accessor: "output_field_label",
      sortable: false,
      Cell: ({ value }: any) => <div className="font-weight-bold">{value}</div>,
    },
    {
      id: "output_value",
      Header: intl.formatMessage({
        id: "settings.prefills.outputValue",
        defaultMessage: "Ouput Value",
      }),
      accessor: (row: any) => row.output_value_label || row.output_value,
      sortable: false,
      Cell: ({ value }: any) => <div>{value}</div>,
    },
    {
      id: "disabled",
      Header: intl.formatMessage({
        id: "settings.prefills.outputFieldDisabled",
        defaultMessage: "Output field disabled",
      }),
      accessor: "disabled",
      sortable: false,
      Cell: ({ value }: any) => <div>{value && <CheckIcon />}</div>,
    },
  ];
  return columns;
};

export default getPrefillsColumns;
